import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import {
  auth as userAuth
} from 'meinian-package/src/utils'
import { AnnotateCount } from '../../action'
import Examine from '../../../../publicComponent/examine'
import styles from './index.module.less'
import './index.less'

export const ClassifyInfo = ({ classifyInfo }) => {
  return <div className={styles['meinian-waterfall-card-image-classifyInfo']}>{classifyInfo !== '识别失败' && classifyInfo === '识别中' ? <span className={styles['meinian-waterfall-card-image-identify']}><Icon type="m-shijian" className={styles['meinian-waterfall-card-image-classifyInfo-icon']} />智能识别中...</span> : classifyInfo}</div>
}

export const StyleStateLabel = ({ viewConfig, auth, itemData }) => {
  return <div className="mn-mark-icons-wrap">
    {
    (userAuth.isPermissions(auth, ['FCS07', 'FS06'])) && viewConfig.markInfo && <div className="mark-icons" style={{ top: 12, left: 12 }}>
      <Examine.Text showText={false} currentBlog={itemData} className="mn-mark-icons-label" />
    </div>
  }
    {
    viewConfig.socialInfo && <div className="info-inspiration-path-wrap">
      <AnnotateCount auth={auth} itemData={itemData} />
    </div>
    }
  </div>
}
